(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_mnr-promise-item"] && !Shopify.designMode) return;
  try {
    // Stock status per variant. Same approach as Horizon's product-price: the
  // variant-picker fetches the re-rendered section and ships it along with
  // variant:update, so the stock text is copied from our own twin in that HTML
  // and the Liquid above stays the single source of truth.
  import('@theme/events').then(({ ThemeEvents }) => {
    if (customElements.get('mnr-promise-stock')) return;

    class MnrPromiseStock extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section, dialog');
        this.section?.addEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
      }

      disconnectedCallback() {
        this.section?.removeEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
      }

      onVariantUpdate = (event) => {
        const { html, newProduct } = event.detail.data;
        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
          return;
        }

        const fresh = html?.querySelector(`mnr-promise-stock[data-block-id="${CSS.escape(this.dataset.blockId)}"]`);
        const freshText = fresh?.querySelector('.mnr-promise__stock-text');
        const text = this.querySelector('.mnr-promise__stock-text');
        if (!freshText || !text) return;

        // Only touch the live region when something changed, or it re-announces.
        if (text.innerHTML !== freshText.innerHTML) text.innerHTML = freshText.innerHTML;
        text.dataset.status = freshText.dataset.status;
        this.closest('.mnr-promise')?.setAttribute('data-stock-status', freshText.dataset.status);
      };
    }

    customElements.define('mnr-promise-stock', MnrPromiseStock);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mnr-editorial-product-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mnr-editorial-slider')) {
    class MnrEditorialSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.mnr-eps__products');
        this.prevButton = this.querySelector('.mnr-eps__nav--prev');
        this.nextButton = this.querySelector('.mnr-eps__nav--next');
        if (!this.track || !this.prevButton || !this.nextButton) return;

        this.prevButton.addEventListener('click', () => this.scrollBy(-1));
        this.nextButton.addEventListener('click', () => this.scrollBy(1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });

        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      scrollBy(direction) {
        this.track.scrollLeft += direction * this.track.clientWidth * 0.8;
      }

      update() {
        const { scrollLeft, clientWidth, scrollWidth } = this.track;
        const scrollable = scrollWidth > clientWidth + 1;
        this.toggleAttribute('data-scrollable', scrollable);
        if (!scrollable) return;
        this.prevButton.disabled = scrollLeft <= 0;
        this.nextButton.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
      }
    }

    customElements.define('mnr-editorial-slider', MnrEditorialSlider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mnrc-product-card"] && !Shopify.designMode) return;
  try {
    // Quick add. Eén gedelegeerde listener op document in plaats van een script
  // per kaart: de Section Rendering API vervangt de sectie-HTML bij elk filter,
  // en een listener op vervangen markup overleeft dat niet.
  //
  // De oude sectie deed .then(res => res.json()).then(() => location = '/cart')
  // zonder res.ok te checken: bij voorraad op ging de klant naar de winkelwagen
  // zonder melding en zonder product. Hier wordt de fout wél getoond.
  if (!window.__mnrcQuickAdd) {
    window.__mnrcQuickAdd = true;

    document.addEventListener('click', async (event) => {
      const btn = event.target.closest('[data-mnrc="quick-add"]');
      if (!btn || btn.disabled) return;

      const card = btn.closest('.mnrc__card');
      const err = card ? card.querySelector('[data-mnrc="quick-add-error"]') : null;
      const variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) return;

      if (err) err.hidden = true;
      btn.dataset.loading = '1';
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });

        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.description || data.message || 'Toevoegen is niet gelukt.');
        }

        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then((r) => (r.ok ? r.json() : null))
          .catch(() => null);

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'mnrc-quick-add',
              data: { source: 'mnrc-product-card', itemCount: cart ? cart.item_count : 1 },
            },
          })
        );

        btn.dataset.added = '1';
        setTimeout(() => {
          btn.dataset.added = '0';
        }, 2200);
      } catch (e) {
        if (err) {
          err.textContent = e.message;
          err.hidden = false;
        }
      } finally {
        btn.dataset.loading = '0';
        btn.disabled = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
